module.exports = __webpack_public_path__ + "img/ausdt_ot.a169d9c0.svg";